// extracted by mini-css-extract-plugin
export default {"Contenedor":"enConstruccion_Contenedor__EBsso"};